









































import { Vue, Component } from 'vue-property-decorator'

declare var window: Window & { BMap: any, BMapLib: any}
const BMap = window.BMap
const BMapLib = window.BMapLib

@Component({
  components: {}
})
export default class Cooperation extends Vue {
  isShowPanel = false
  categories = [
    { key: '1', val: '全球说产品代理' },
    { key: '2', val: '全球说学习卡产品合作' },
    { key: '3', val: '全球说多语课程合作（Mini）' },
    { key: '4', val: '全球说多语课程合作（Pro）' },
    { key: '5', val: '联合国教科文组织 - 全球说儿童多语实验班' }
  ]
  selectCategory = this.categories[0]
  cooperationData = {
    '1': [],
    '2': [
      {
        name: '忻州市第六中学',
        area: '山西忻州',
        address: '忻州市第六中学',
        phone: '1339350****任老师',
        email: '86234****@163.com',
        memo: ''
      },
      {
        name: '忻州市七一路小学',
        area: '山西忻州',
        address: '忻州市七一路小学',
        phone: '1893501****李老师',
        email: '36712****@163.com',
        memo: ''
      },
      {
        name: '忻州市第二实验小学',
        area: '山西忻州',
        address: '忻州市第二实验小学',
        phone: '1853505****刘老师',
        email: '36573****@163.com',
        memo: ''
      },
      {
        name: '忻州实验小学',
        area: '山西忻州',
        address: '忻州实验小学',
        phone: '1380344****靳老师',
        email: '98323****@163.com',
        memo: ''
      },
      {
        name: '忻州第五中学',
        area: '山西忻州',
        address: '忻州第五中学',
        phone: '1393503****刘老师',
        email: '68523****@163.com',
        memo: ''
      },
      {
        name: '忻州市长征路小学',
        area: '山西忻州',
        address: '忻州市长征路小学',
        phone: '1309903****赵老师',
        email: '75323****@163.com',
        memo: ''
      },
      {
        name: '忻州市第十三中学',
        area: '山西忻州',
        address: '忻州市第十三中学',
        phone: '1860350****谢老师',
        email: '37689****@163.com',
        memo: ''
      },
      {
        name: '沱阳中学',
        area: '山西忻州',
        address: '沱阳中学',
        phone: '1534062****王老师',
        email: '42403****@163.com',
        memo: ''
      },
      {
        name: '保德县第二小学',
        area: '山西忻州',
        address: '保德县第二小学',
        phone: '1864930****马老师',
        email: '32872****@163.com',
        memo: ''
      },
      {
        name: '代县实验小学',
        area: '山西忻州',
        address: '代县实验小学',
        phone: '1311120****白老师',
        email: '54277****@163.com',
        memo: ''
      },
      {
        name: '代县第四中学校 ',
        area: '山西忻州',
        address: '代县第四中学校 ',
        phone: '1593431****郭老师',
        email: '36877****@163.com',
        memo: ''
      },
      {
        name: '定襄县第二实验小学',
        area: '山西忻州',
        address: '定襄县第二实验小学',
        phone: '1393506****张老师',
        email: '36852****@163.com',
        memo: ''
      },
      {
        name: '繁峙县滨河小学',
        area: '山西忻州',
        address: '繁峙县滨河小学',
        phone: '1863501****张老师',
        email: '24752****@163.com',
        memo: ''
      },
      {
        name: '繁峙县实验小学',
        area: '山西忻州',
        address: '繁峙县实验小学',
        phone: '1365350****郑老师',
        email: '68952****@163.com',
        memo: ''
      },
      {
        name: '河曲县双语育英学校',
        area: '山西忻州',
        address: '河曲县双语育英学校',
        phone: '1399417****李老师',
        email: '64412****@163.com',
        memo: ''
      },
      {
        name: '河曲县实验小学',
        area: '山西忻州',
        address: '河曲县实验小学',
        phone: '1393509****范老师',
        email: '77523****@163.com',
        memo: ''
      },
      {
        name: '静乐县爱乐小学',
        area: '山西忻州',
        address: '静乐县爱乐小学',
        phone: '1309767****郭老师',
        email: '38653****@163.com',
        memo: ''
      },
      {
        name: '岢岚县东街示范小学',
        area: '山西忻州',
        address: '岢岚县东街示范小学',
        phone: '1399408****王老师',
        email: '24223****@163.com',
        memo: ''
      },
      {
        name: '岢岚县西街实验小学',
        area: '山西忻州',
        address: '岢岚县西街实验小学',
        phone: '1399417****王老师',
        email: '32536****@163.com',
        memo: ''
      },
      {
        name: '宁武县实验小学',
        area: '山西忻州',
        address: '宁武县实验小学',
        phone: '1323350****杜老师',
        email: '31412****@163.com',
        memo: ''
      },
      {
        name: '偏关县第二小学',
        area: '山西忻州',
        address: '偏关县第二小学',
        phone: '1393509****赫老师',
        email: '58711****@163.com',
        memo: ''
      },
      {
        name: '偏关县实验小学',
        area: '山西忻州',
        address: '偏关县实验小学',
        phone: '1309767****王老师',
        email: '69534****@163.com',
        memo: ''
      },
      {
        name: '神池县南关明德小学',
        area: '山西忻州',
        address: '神池县南关明德小学',
        phone: '1360350****朱老师',
        email: '30257****@163.com',
        memo: ''
      },
      {
        name: '神池县第三中学 ',
        area: '山西忻州',
        address: '神池县第三中学 ',
        phone: '1530350****余老师',
        email: '37323****@163.com',
        memo: ''
      },
      {
        name: '五台县实验小学',
        area: '山西忻州',
        address: '五台县实验小学',
        phone: '1550350****张老师',
        email: '37253****@163.com',
        memo: ''
      },
      {
        name: '五台县东冶实验小学 ',
        area: '山西忻州',
        address: '五台县东冶实验小学 ',
        phone: '1375305****徐老师',
        email: '68553****@163.com',
        memo: ''
      },
      {
        name: '五台县第二中学',
        area: '山西忻州',
        address: '五台县第二中学',
        phone: '1393501****杨老师',
        email: '23644****@163.com',
        memo: ''
      },
      {
        name: '五寨县第四小学',
        area: '山西忻州',
        address: '五寨县第四小学',
        phone: '1503443****魏老师',
        email: '12257****@163.com',
        memo: ''
      },
      {
        name: '五寨县第一小学',
        area: '山西忻州',
        address: '五寨县第一小学',
        phone: '1383507****曹老师',
        email: '55532****@163.com',
        memo: ''
      },
      {
        name: '忻府区东方红学校',
        area: '山西忻州',
        address: '忻府区东方红学校',
        phone: '1520350****张老师',
        email: '37254****@163.com',
        memo: ''
      },
      {
        name: '原平市实达中学',
        area: '山西忻州',
        address: '原平市实达中学',
        phone: '1860350****边老师',
        email: '58742****@163.com',
        memo: ''
      },
      {
        name: '兴原实验小学',
        area: '山西忻州',
        address: '兴原实验小学',
        phone: '1593432****王老师',
        email: '98231****@163.com',
        memo: ''
      }
    ],
    '3': [
      {
        name: '北京加拿大国际学校',
        area: '北京',
        address: '北京市朝阳区亮马桥路38号',
        phone: '010-6465****',
        email: '——',
        memo: ''
      },
      {
        name: '启明星国际学校',
        area: '北京',
        address: '北京市朝阳区顺白路2号',
        phone: '010-6465****',
        email: '——',
        memo: ''
      },
      {
        name: '可儿将台国际园',
        area: '北京',
        address: '北京市朝阳区将台乡东八间房临甲10号',
        phone: '010-5288****',
        email: '——',
        memo: ''
      },
      {
        name: '可儿丽水嘉园国际园',
        area: '北京',
        address: '北京市朝阳公园南路丽水嘉园12号楼',
        phone: '010-6465****',
        email: '——',
        memo: ''
      },
      {
        name: '家育苑建外soho国际园',
        area: '北京',
        address: '北京市朝阳区东三中环路39号建外SOHO西区',
        phone: '010-6465****',
        email: '——',
        memo: ''
      },
      {
        name: '乐儿金港国际园',
        area: '北京',
        address: '北京市朝阳区西大望路19号',
        phone: '010-5288****',
        email: '——',
        memo: ''
      },
      {
        name: '可儿康城国际园',
        area: '北京',
        address: '北京市双桥东路9号康城花园别墅',
        phone: '010-6465****',
        email: '——',
        memo: ''
      },
      {
        name: '可儿苹果国际园',
        area: '北京',
        address: '北京市朝阳区东四环北路6号阳光上东C区南门',
        phone: '010-6465****',
        email: '——',
        memo: ''
      },
      {
        name: '可儿阳光上东园',
        area: '北京',
        address: '北京北京朝阳东四环北路6号阳光上东可儿',
        phone: '010-5288****',
        email: '——',
        memo: ''
      },
      {
        name: '贝儿达龙骏景园',
        area: '北京',
        address: '北京市大兴区旧宫镇云龙家园小区11号楼',
        phone: '010-6465****',
        email: '——',
        memo: ''
      },
      {
        name: '贝儿宏盛托幼中心',
        area: '北京',
        address: '北京市大兴区西红门宏盛家园西园区内',
        phone: '010-6465****',
        email: '——',
        memo: ''
      },
      {
        name: '家育苑幼托中心',
        area: '北京',
        address: '北京市朝阳区东三环中路39号建外SOHO',
        phone: '010-5288****',
        email: '——',
        memo: ''
      },
      {
        name: '可儿观唐国际园',
        area: '北京',
        address: '北京市朝阳区东四环北路6号',
        phone: '010-6465****',
        email: '——',
        memo: ''
      },
      {
        name: '新世纪未来之星园',
        area: '北京',
        address: '北京市海淀区学院路新区14号院内',
        phone: '010-6465****',
        email: '——',
        memo: ''
      },
      {
        name: '新世纪长安新城园',
        area: '北京',
        address: '北京市丰台区大成路长安新城社区内',
        phone: '010-5288****',
        email: '——',
        memo: ''
      },
      {
        name: '新世纪天通苑园',
        area: '北京',
        address: '北京市天通苑本二区10号楼',
        phone: '010-8482****',
        email: '——',
        memo: ''
      },
      {
        name: '新世纪农大园',
        area: '北京',
        address: '北京市昌平区回龙观田园风光雅苑小区',
        phone: '010-8483****',
        email: '——',
        memo: ''
      },
      {
        name: '新世纪龙泽苑园',
        area: '北京',
        address: '北京市昌平区龙泽苑28号楼旁边',
        phone: '010-8484****',
        email: '——',
        memo: ''
      },
      {
        name: '石景山可儿幼儿园',
        area: '北京',
        address: '北京市石景山区鲁谷东街20',
        phone: '010-6865****',
        email: '——',
        memo: ''
      },
      {
        name: '新世纪新华社园',
        area: '北京',
        address: '北京市昌平区龙泽苑28号楼旁边',
        phone: '010-6866****',
        email: '——',
        memo: ''
      },
      {
        name: '新世纪滨河园',
        area: '北京',
        address: '北京市朝阳区滨河居住区1号',
        phone: '010-6186****',
        email: '——',
        memo: ''
      },
      {
        name: '大连新世纪（虎滩）国际园',
        area: '大连',
        address: '辽宁省大连市中山区虎滩路166号',
        phone: '010-8483****',
        email: '——',
        memo: ''
      },
      {
        name: '大连新世纪锦秀园',
        area: '大连',
        address: '辽宁省大连新世纪锦秀园',
        phone: '010-8484****',
        email: '——',
        memo: ''
      },
      {
        name: '大连可儿（幸福E家）国际园',
        area: '大连',
        address: '辽宁省大连市幸福E家',
        phone: '010-6865****',
        email: '——',
        memo: ''
      },
      {
        name: '南京可儿国际园',
        area: '南京',
        address: '南京市湘天国际花园附近',
        phone: '010-6866****',
        email: '——',
        memo: ''
      },
      {
        name: '贵阳可儿国际幼儿园',
        area: '贵阳',
        address: '贵阳市世纪城K区龙兴苑旁',
        phone: '010-6862****',
        email: '——',
        memo: ''
      },
      {
        name: '深圳蛇口国际幼稚园',
        area: '深圳',
        address: '深圳市石云路30号蛇口荣山小区13栋',
        phone: '010-6186****',
        email: '——',
        memo: ''
      }
    ],
    '4': [
      {
        name: '山西现代双语学校',
        area: '山西',
        address: '太原市太榆路中段汇通北路409号',
        phone: '0354-3283****',
        email: '——',
        memo: ''
      }
    ],
    '5': [
      {
        name: '北京迈德天地教育科技有限公司',
        area: '北京',
        address: '朝阳区公园南路10号院中央公园广场A1座3层301',
        phone: '010-8230****',
        email: '——',
        memo: ''
      }
    ]
  }
  map: any
  myGeo: any
  mounted () {
    this.map = new BMap.Map('allmap', { minZoom: 5, maxZoom: 12 }) // 创建地图实例
    let point = new BMap.Point(116.404, 39.915) // 创建点坐标
    this.map.centerAndZoom(point, 5) // 初始化地图，设置中心点坐标和地图级别
    this.map.enableScrollWheelZoom(true)
    this.map.panTo(new BMap.Point(104.262232, 37.154345))
    this.myGeo = new BMap.Geocoder()

    this.searchResult()
  }

  togglePanel () {
    let ul = $('.select-option')
    if (ul.css('display') === 'none') {
      ul.slideDown()
      $('.select-search p').addClass('select')
    } else {
      ul.slideUp()
      $('.select-search p').removeClass('select')
    }
  }

  changeCategory (category: any) {
    this.selectCategory = category
    $('.select-option').hide()
    $('.select-search p').removeClass('select')
    this.searchResult()
  }

  index = 0
  searchResult (this: any) {
    this.index = 0
    this.map.clearOverlays()
    if (this.cooperationData[this.selectCategory.key].length) {
      // 地图地址解析
      this.bdGEO()
    }
  }

  bdGEO (this: any) {
    let add = this.cooperationData[this.selectCategory.key][this.index]
    this.geocodeSearch(add)
    this.index++
  }

  geocodeSearch (this: any, add: any) {
    if (this.index < this.cooperationData[this.selectCategory.key].length) {
      setTimeout(this.bdGEO, 400)
    }
    if (add) {
      var addr = add.address
      this.myGeo.getPoint(addr, (point: any) => {
        if (point) {
          var address = new BMap.Point(point.lng, point.lat)
          var sContent =
            `<div>
              <p style="word-break:break-all;overflow-wrap:break-word;padding: 0 18px;">
                <span style="font-size:14px; font-weight:bold; color:#333333; line-height: 20px;">
                  ${add.name}
                </span>
              </p>
            </div>`
          this.addMarker(address, sContent)
        }
      }, add.area)
    }
  }

  addMarker (point: any, content: string) {
    let marker = new BMap.Marker(point)
    this.map.addOverlay(marker)

    marker.addEventListener('mouseover', (e:any) => {
      this.openInfo(content, e)
    })
  }

  lastInfoBox: any
  openInfo (content: string, e: any) {
    var p = e.target
    var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat)
    // 创建信息窗口对象
    var opt = {
      offset: new BMap.Size(-10, -8),
      boxStyle: {
        width: '176px',
        height: '98px',
        background: 'url("/img/map-infowin-bg.svg") no-repeat center top',
        padding: '12px',
        borderRadius: '5px',
        marginLeft: '6px'
      },
      closeIconMargin: '-4px 28px 0 0',
      closeIconUrl: '/img/map-infowin-close.svg',
      enableAutoPan: true,
      alignBottom: false
    }
    if (this.lastInfoBox) {
      this.lastInfoBox.close()
    }
    var infoBox = new BMapLib.InfoBox(this.map, content, opt)
    this.lastInfoBox = infoBox
    infoBox.open(point)
  }
}
